import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ui-infotext-expandable',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './infotext-expandable.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfotextExpandableComponent {
  lines = input<4 | 8>(8);
  protected expanded = signal(false);

  protected toggle(event: MouseEvent): void {
    (event.currentTarget as HTMLElement).focus();
    this.expanded.update(expanded => !expanded);
  }
}
